


























































































import { Component } from 'vue-property-decorator';
import CommonMixin from "@/utils/CommonMixin";
import cr from "@/CompositionRoot";
import { EventReg, EventRegItem, EventRegItems, EventRegItemStateDto, FormFields, } from "frontend-common";
import TextEditor from "@/components/dashboard/common/TextEditor.vue";
import AddField from "@/components/dashboard/AddField.vue";
import vuedraggable from "vuedraggable";
import { BvTableFieldArray } from "bootstrap-vue/src/components/table";
import RegItemsCount from "@/components/dashboard/reg/RegItemsCount.vue";
import FormButtons from "@/components/dashboard/common/form/FormButtons.vue";
import EditRegItemDialog from "@/components/dashboard/reg/EditRegItemDialog.vue";
import { millisToDmHm } from "@/utils/date-utils";

@Component({
    components: { EditRegItemDialog, FormButtons, RegItemsCount, AddField, TextEditor, vuedraggable }
})
export default class extends CommonMixin {

    private progress = false
    private showAllFields = false
    private filter = ""
    private filteredCount = 0
    private regItemToEdit: EventRegItem = new EventRegItem()

    created() {
        this.refresh()
    }

    mounted() {
        const route = this.$route
        const refs = this.$refs
        setTimeout(function () {
            if (!route.meta?.fromHistory) {
                (refs.refresh as HTMLElement).focus()
            }
        }, 100)
    }

    get uuid(): string {
        return this.$route.params.uuid
    }

    get regItems(): EventRegItems {
        return cr.myEventsModule.regItemsByEvent(this.uuid)
    }

    regItemById(regItemId: number): EventRegItem | undefined {
        return this.regItems.find(regItem => regItem.id === regItemId)
    }

    get eventReg(): EventReg {
        return cr.myEventsModule.regByEvent(this.uuid)
    }

    get customFields(): FormFields {
        return this.eventReg.form.fields
    }

    refresh(showSuccess = false) {
        this.progress = true
        cr.myEventsService.fetchRegItems(this.uuid)
            .then(value => this.showRefreshSuccessful(showSuccess))
            .catch(reason => this.showError(reason))
            .finally(() => this.progress = false)
    }

    showRefreshSuccessful(showSuccess: boolean) {
        if (showSuccess) {
            const title = this.$t("dashboard.common.refresh") as string
            const message = this.$t("dashboard.regItems.refreshSuccess") as string
            this.showToast(title, message, "success")
        }
    }

    get tableFields(): BvTableFieldArray {
        const result: BvTableFieldArray = []
        const labelDate = this.$t("dashboard.reg.fields.other.date") as string
        const labelState = this.$t("dashboard.reg.fields.other.state") as string
        const labelActions = this.$t("dashboard.reg.fields.other.actions") as string
        const labelEmail = this.$t("dashboard.reg.fields.required.email") as string
        const labelFirstName = this.$t("dashboard.reg.fields.required.firstName") as string
        const labelLastName = this.$t("dashboard.reg.fields.required.lastName") as string
        result.push({
            key: "created",
            label: labelDate,
            sortable: true,
            formatter: (value: any, key: string, item: any) => millisToDmHm(value, this.$cr.i18n.locale)
        })
        result.push({ key: "email", sortable: true, label: labelEmail })
        result.push({ key: "state", sortable: true, label: labelState })
        result.push({ key: "firstName", sortable: true, label: labelFirstName })
        result.push({ key: "lastName", sortable: true, label: labelLastName })
        if (this.showAllFields) {
            this.eventReg.form.fields.forEach(field => result.push({
                key: String(field.id),
                label: field.title,
                sortable: true,
                thStyle: { minWidth: '10rem' }
            }))
        }
        result.push({ key: "actions", label: labelActions, sortable: false })
        return result
    }

    get tableItems(): Array<any> {
        const result: Array<any> = []
        if (!this.regItems) {
            return result
        }
        const labelStateConfirmed = this.$t("dashboard.reg.fields.other.stateConfirmed") as string
        const labelStateSubmitted = this.$t("dashboard.reg.fields.other.stateSubmitted") as string
        const fieldsMap = this.eventReg.form.fieldsMap()
        this.regItems.forEach(regItem => {
            const item: any = {
                regItemId: regItem.id,
                email: regItem.email,
                state: regItem.state === EventRegItemStateDto.CONFIRMED ? labelStateConfirmed : labelStateSubmitted,
                firstName: regItem.firstName,
                lastName: regItem.lastName,
                created: regItem.created,
            }
            regItem.formFieldValues.forEach(fieldValue => {
                const id = String(fieldValue.fieldId)
                const formField = fieldsMap[id]
                if (formField) {
                    item[id] = formField.valueTyped(fieldValue)
                }
            })
            if (this.showAllFields) {
                item["_showDetails"] = false
            }
            result.push(item)
        })
        return result
    }

    onFiltered(filteredItems: Array<any>) {
        this.filteredCount = filteredItems.length
    }

    onRegItemEditClicked(regItemId: number) {
        this.regItemToEdit = this.regItemById(regItemId)!
        this.$bvModal.show("edit-regItem")
    }

    onRegItemDeleteClicked(regItemId: number) {
        const regItemToDelete = this.regItemById(regItemId)!
        const name = regItemToDelete.firstName + " " + regItemToDelete.lastName
        this.disableShortcuts()
        this.$bvModal.msgBoxConfirm(this.$t("dashboard.regItems.delete.confirm", { name }) as string, {
            title: this.$t("dashboard.regItems.delete.title") as string,
            okVariant: "outline-danger",
            okTitle: this.$t("dashboard.common.delete") as string,
            cancelVariant: "outline",
            cancelTitle: this.$t("dashboard.common.cancel") as string,
            centered: true,
        }).then(result => {
            this.enableShortcuts()
            if (result) {
                cr.myEventsService.deleteRegItem(this.uuid, regItemId)
                    .catch(reason => this.showError(reason))
            }
        })
    }

    onRegItemEdited() {
        this.$bvModal.hide("edit-regItem")
    }

    onRegItemEditCancelled() {
        this.$bvModal.hide("edit-regItem")
    }
}
